<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">
        <div class="title" v-if="getModalData.id">Edit Platform</div>
        <div class="title" v-if="!getModalData.id">Add Platform</div>
      </h5>
      <button type="button" class="close" @click="$store.dispatch('closeModal', true)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form class="form" @submit.prevent="onSubmit">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" v-model="form.name"/>
        </div>
        <div class="form-group" v-if="!this.thirdParty">
          <label>Coords</label>
          <input type="text" class="form-control" v-model="form.coords"/>
        </div>
        <div class="form__btn position-relative">
          <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4" v-if="getModalData.id">
            <img src="../../assets/img/btn-ok-icon.png"> <span>Save</span>
          </b-button>
          <b-button variant="primary" class="mb-2 btn-delete float-right position-absolute" style="top: 0; right: 0;" v-if="getModalData.id" @click="onDelete">
            <b-icon icon="trash" aria-label="Delete"></b-icon>
          </b-button>
          <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4" v-if="!getModalData.id">
            <img src="../../assets/img/btn-ok-icon.png"> <span>Add</span>
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'

  export default {
    name: 'ModalPlatform',
    computed: {
      ...mapGetters([
        'getModalData',
      ]),
    },
    data() {
      return {
        form: {
          station_id: '',
          name: '',
          coords: '',
        },
        thirdParty: null
      }
    },
    mounted() {
      if (this.getModalData.third_party) this.thirdParty = 1
      if (this.getModalData.id) {
        this.form = {
          name: this.getModalData.name,
          coords: this.getModalData.coords,
        }
      }
      this.form.station_id = this.getModalData.station_id
    },
    methods: {
      ...mapActions([
        'storePlatform',
        'updatePlatform',
        'destroyPlatform',
        'setToast',
        'closeModal',
      ]),
      ...mapMutations([
        'setStation'
      ]),
      onSubmit: function () {
        if (this.getModalData.id)
          this.updatePlatform([this.getModalData.id, this.form, this.thirdParty])
        else {
          let payload = this.form
          payload.third_party = this.thirdParty
          this.storePlatform(payload)
        }
      },
      onDelete() {
        this.$confirm({
          message: 'Delete platform ' + this.getModalData.name + '?',
          callback: confirm => {
            if (confirm) {
              this.destroyPlatform({id: this.getModalData.id, third_party: this.thirdParty})
              this.closeModal(true)
              this.setStation({})
            }
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>